import { SchoolService, BaseService } from "@/services/school.service";

const PostService = {

    getByType(type, visibility) {
        return SchoolService.getAll("posts?types=" + type + "&visibility=" + visibility)
    },

    getByCourse(courseId) {
        return SchoolService.getAll("courses/" + courseId + "/posts")
    },

    // reads
    getUserReads(userId) {
        return SchoolService.getAll("users/" + userId + "/posts/readings")
    },

    markAsRead(payload) {
        return SchoolService.create("posts/readings", payload)
    },

    getShared(object) {
    	return SchoolService.getAll("posts/", object.identifier + "?include=shared")
    },

    // crud
    add(payload) {
    	return SchoolService.create("posts", payload)
    },

    update(object) {
    	return SchoolService.update("posts", object.identifier, object)
    },

    delete(object) {
    	return SchoolService.delete("posts", object.identifier, null)
    },
    
}

export { PostService };